import { getApi } from "./api_instance";

export const getUserById = async (_id, dispatch) => {
  try {
    const response = await getApi({
      apiUrl: `/api/user/detail/${_id}`,
      sendToken: true,
      dispatch,
    });

    if (response.success) {
      return response.data;
    } else {
      throw new Error(response.message || 'Failed to fetch user data');
    }
  } catch (error) {
    console.error('getUserById Error:', error);
    throw error;
  }
};
